<template>
  <div class="row" ref="checkoutForm">
    <div class="col-lg-6">
      <div class="side-cart checkout-cart">
        <div class="side-cart-content fixed-cart">
          <brand-logo v-if="!domainBasedBrand"></brand-logo>
          <div class="delivery-timeline" v-if="isFloorTableAvailable.table_id">
            <div class="media">
              <div class="icon-main d-none d-lg-block">
                <div class="icon-round">
                  <svg width="25" height="25" fill="none">
                    <use xlink:href="#dineIn" />
                  </svg>
                </div>
              </div>
              <div class="media-body media-body-ai">
                <div class="timeline-card">
                  <div class="delivery-content saved-payment">
                    <p v-if="dineinArea(isFloorTableAvailable.floor_id)">
                      {{ _T('Area') }}:
                      <b class="text-capitalize">
                        {{ dineinArea(isFloorTableAvailable.floor_id).name }}
                      </b>
                    </p>
                    <p v-if="dineinTableDetails">
                      {{ _T('Table number') }}:
                      <b>
                        <span
                          :class="'shape ' + dineinTableDetails.table_shape"
                        >
                          {{ dineinTableDetails.number }}
                        </span>
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="delivery-timeline"
            v-if="
              !isFloorTableAvailable.table_id &&
                (is_customer_logged_in || guest_checkout)
            "
          >
            <template>
              <user-address></user-address>
              <store-selector
                v-if="availableStores && availableStores.length > 1"
              ></store-selector>
              <delivery-time v-if="currentBrand.schedule_order"></delivery-time>
            </template>
          </div>
          <unavailable-items
            v-if="unavailable_cart_items.length"
          ></unavailable-items>
          <item></item>
        </div>
      </div>
    </div>
    <div class="col-lg-6 pt-2 checkout-background">
      <!-- <h4>{{ _T('Complete Checkout') }}</h4> -->
      <div class="side-cart checkout-cart">
        <div class="side-cart-content">
          <div class="delivery-timeline" v-if="!isFloorTableAvailable.table_id">
            <checkout-login-form
              v-if="!is_customer_logged_in"
              ref="checkoutLoginForm"
            ></checkout-login-form>
          </div>
          <coupon></coupon>
          <cashback />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckoutLoginForm from './Payment/CheckoutLoginform'
import UserAddress from './Payment/UserAddress'
import DeliveryTime from './Payment/DeliveryTime'
import StoreSelector from './Payment/StoreSelector'
import BrandLogo from './Payment/BrandLogo'
import Item from './Payment/Items'
import UnavailableItems from './Payment/UnavailableCartItems'
import Coupon from './Payment/Coupon'
import Cashback from './Payment/Cashback'
import { mapGetters } from 'vuex'

export default {
  components: {
    CheckoutLoginForm,
    StoreSelector,
    UserAddress,
    DeliveryTime,
    BrandLogo,
    Item,
    UnavailableItems,
    Cashback,
    Coupon,
  },
  computed: {
    ...mapGetters([
      '_T',
      'is_customer_logged_in',
      'guest_checkout',
      'isFloorTableAvailable',
      'dineinArea',
      'dineinTable',
      'availableStores',
      'domainBasedBrand',
      'unavailable_cart_items',
      'currentBrand',
      'currentStore',
    ]),
    dineinTableDetails() {
      if (this.isFloorTableAvailable.table_id) {
        return this.dineinTable(this.isFloorTableAvailable.table_id)
      }
      return undefined
    },
  },
  watch: {
    currentStore(newVal) {
      if (newVal) {
        this.$store.dispatch('calculateLoyaltyAmountForItem')
      }
    }
  }
}
</script>

<style lang="scss">
.checkout-background {
  background: #fefdfd;
  border-top: 2px solid #ececec;
  box-shadow: 0px 2px 4px 1px #eeeded;
  height: 100%;
}
@media (min-width: 992px) {
  .fixed-cart {
    margin-top: 12px;
    padding: $px17 0 0 $px5;
    max-height: calc(100vh - #{$px135});
    width: 38%;
    position: fixed;
    left: 12%;
    top: $px86;
    overflow: auto;
    /* width */
    &::-webkit-scrollbar {
      width: $px6;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: $scrollbar-track;
      border-radius: $px6;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb;
      border-radius: $px4;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: darken($scrollbar-track, 0.2);
    }
  }
}
.shape {
  background-color: rgb(57, 157, 77);
  border-radius: 80px;
  margin-bottom: 30px;
  margin-left: 10px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.45);
  text-align: center;
  color: #fff;
}

.circle {
  height: 35px;
  max-width: 35px;
  border-radius: 50%;
}

.square {
  height: 35px;
  max-width: 35px;
  border-radius: 5%;
}

.rectangle {
  border-radius: 5%;
  height: 35px;
  max-width: 50px;
}
.delivery-timeline {
  padding-top: $px30;
  padding-right: $px15;
  padding-bottom: $px30;
  .media {
    .icon-main {
      padding: $px4 $px5;
      background-color: $white;
    }
    .icon-round {
      background-color: $white;
      border-radius: 100%;
      width: $px50;
      height: $px50;
      display: flex;
      justify-content: center;
      background-color: $warning-color;
      //   border: 4px solid lighten($warning-color, 30%);
      border: $px4 solid $warning-color;
      svg {
        width: $px25;
        height: $px40;
      }
    }
    .media-body {
      margin-left: $px10;
      position: relative;
      padding-bottom: $px20;
      margin-right: $px8;
      .timeline-card {
        padding: calc(
            #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
          )
          calc(#{$px15} + (36 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
        border: $px1 solid $dark-border;
        border-radius: $px4;
        ul.timeul {
          display: flex;
          li {
            &:first-child {
              width: 43%;
            }
            &:last-child {
              margin-left: auto;
              text-align: right;
            }
          }
        }
        .dine-booking {
          margin-bottom: calc(
            #{$px20} + (37 - 20) * ((100vw - #{$px320}) / (1920 - 320))
          );
          .media {
            align-items: center;
            .icon-booking {
              width: $px52;
              height: $px52;
              border: $px1 solid $light-border;
              border-radius: $px8;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .media-body {
              padding-bottom: 0;
              h6 {
                line-height: $px22;
                letter-spacing: 0.5px;
                margin-bottom: $px4;
              }
              h5 {
                font-weight: 600;
                margin-bottom: 0;
              }
            }
          }
          .row {
            [class^='col-'] {
              &:last-child,
              &:nth-child(3) {
                margin-top: calc(
                  #{$px15} + (25 - 15) * ((100vw - #{$px320}) / (1920 - 320))
                );
              }
            }
          }
        }
      }
      &::before {
        position: absolute;
        content: '';
        height: 100%;
        border-left: 2px dashed $dark-border;
        top: 0;
        left: -41.5px;
        margin: $px8 0;
        z-index: -1;
      }
      h4 {
        font-weight: 600;
        margin-bottom: calc(
          #{$px12} + (28 - 12) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      .delivery-content {
        h6 {
          font-weight: 500;
          line-height: $px17;
          color: $light-font;
          margin-bottom: calc(
            #{$px6} + (12 - 6) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
        img,
        h5 {
          display: inline-block;
        }
        img {
          vertical-align: top;
        }
        svg {
          display: inline-block;
          vertical-align: top;
          margin-top: $px4;
        }
        > img {
          padding-top: $px5;
        }
        h5 {
          width: 57%;
          padding-left: calc(
            #{$px6} + (12 - 6) * ((100vw - #{$px320}) / (1920 - 320))
          );
          margin-bottom: 0;
          padding-top: $px7;
        }
        span {
          width: 100%;
          // padding-left: calc(
          //   #{$px6} + (12 - 6) * ((100vw - #{$px320}) / (1920 - 320))
          // );
          margin-bottom: 0;
          padding-top: $px4;
          display: inline-block;
          a {
            display: block;
            color: $warning-color;
            font-weight: 600;
            padding-left: 0;
            padding-top: calc(
              #{$px8} + (14 - 8) * ((100vw - #{$px320}) / (1920 - 320))
            );
          }
        }
        .radio-credit {
          position: relative;
          h6 {
            font-weight: 600;
            font-size: 13.5px;
            line-height: $px21;
            display: flex;
            align-items: center;
            color: $font-color;
            display: inline-block;
            padding-left: $px10;
            margin-bottom: 0;
            span {
              color: $light-font;
            }
          }
          label {
            width: 45%;
            position: relative;
            margin-left: calc(
              #{$px12} + (20 - 12) * ((100vw - #{$px320}) / (1920 - 320))
            );
            + label {
              margin-left: calc(
                #{$px12} + (20 - 12) * ((100vw - #{$px320}) / (1920 - 320))
              );
            }
          }
          input {
            position: absolute;
            top: 12%;
          }
          .saved-details {
            padding-left: calc(
              #{$px25} + (40 - 25) * ((100vw - #{$px320}) / (1920 - 320))
            );
            display: inline-block;
            h5 {
              font-weight: 400;
            }
          }
          a {
            color: $color-primary;
            span {
              vertical-align: middle;
            }
          }
        }
        .other-method {
          margin-top: calc(
            #{$px16} + (26 - 16) * ((100vw - #{$px320}) / (1920 - 320))
          );
          padding-top: calc(
            #{$px16} + (26 - 16) * ((100vw - #{$px320}) / (1920 - 320))
          );
          border-top: $px1 solid $light-border;
          h4 {
            margin-bottom: #{$px15};
          }
        }
        &.saved-payment {
          h5 {
            font-weight: 600;
            padding-left: 0;
            margin-bottom: calc(
              #{$px18} + (32 - 18) * ((100vw - #{$px320}) / (1920 - 320))
            );
          }
        }
      }
    }
    &:nth-child(2) {
      .icon-round {
        background-color: $color-secondary;
        //   border: 4px solid lighten($secondary-color, 40%);
        border: $px4 solid $color-secondary;
      }
    }
    &:last-child {
      .icon-round {
        background-color: $color-tertiary;
        border: $px4 solid $tertiary-light;
      }
      .media-body {
        &::before {
          display: none;
        }
      }
    }
  }
}
.checkout-cart {
  &.side-cart {
    position: fixed;
    background-color: $white;
    width: $px580;
    right: -$px580;
    top: 0;
    height: 100vh;
    transition: all 0.5s ease;
    z-index: 9;
    .brand-section {
      padding: $px30;
      display: flex;
      align-items: center;
      border-bottom: $px1 solid $light-border;
      .brand-img {
        margin-right: $px25;
        width: $px128;
        height: $px64 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $px10;
        border: $px3 solid rgba(var(--color-dark-border-source), 0.9);
        padding: $px2;
        img,
        .bg-size {
          width: 100%;
          height: auto;
          // border-radius: 100%;
        }
      }
      .brand-detail {
        h6 {
          text-transform: uppercase;
          line-height: $px22;
          letter-spacing: 0.005em;
          color: $light-font;
          margin-bottom: 0;
        }
        h3 {
          margin-bottom: 0;
          line-height: $px29;
          letter-spacing: 0.02em;
          color: $font-color;
          font-weight: 700;
          text-transform: capitalize;
        }
      }
    }
    &.checkout-cart {
      position: relative;
      right: 0;
      top: 0;
      background: transparent;
      width: 100%;
      height: 100%;
      z-index: 1;
      .side-cart-content {
        @extend %default-scroll;
        &:hover {
          &.custom-scrollbar {
            color: rgba(68, 102, 242, 0.1);
          }
        }
        .cart-checkout {
          bottom: unset;
          .cancel-link {
            padding: $px15 0;
            display: block;
            font-weight: 600;
            font-size: $px14;
            line-height: $px22;
            letter-spacing: 0.5px;
            color: $font-color;
          }
        }
      }
      .brand-section {
        padding: calc(
            #{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320))
          )
          0 calc(#{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
          calc(#{$px25} + (50 - 25) * ((100vw - #{$px320}) / (1920 - 320)));
        border-bottom: none;
        .brand-detail {
          h6 {
            font-weight: 600;
          }
        }
      }
      .summary {
        z-index: -1;
        > ul {
          width: 97%;
          // max-height: $px540;
          // overflow: auto;
          &::-webkit-scrollbar {
            width: 0 !important ;
          }
        }
        .empty-item {
          text-align: center;
          img {
            width: 32%;
          }
          h5 {
            margin-top: calc(
              #{$px20} + (43 - 20) * ((100vw - #{$px320}) / (1920 - 320))
            );
            font-weight: bold;
          }
          p {
            font-size: $px12;
            line-height: $px17;
            width: 75%;
            margin: 0 auto;
            a {
              font-weight: 600;
            }
          }
        }
      }
      .no-item {
        ul {
          padding-top: 0;
        }
        .summary {
          height: auto;
        }
      }
      .summary,
      .cashback {
        ul {
          // padding-right: $px32;
        }
        padding: 0 0 0
          calc(#{$px8} + (50 - 25) * ((100vw - #{$px320}) / (1920 - 320)));
        h4 {
          margin-bottom: calc(
            #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
          );
          font-weight: 600;
        }
        .summary-card {
          padding: calc(
            #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
          );
          background-color: $white;
          border-radius: $px4;
          border: $px1 solid $dark-border;
          display: block;
          .item-content {
            h5 {
              font-weight: 600;
              margin-bottom: 0;
            }
            ul {
              width: 80%;
              margin-left: -$px5;
              li {
                font-weight: 600;
                font-size: $px12;
                line-height: $px15;
                letter-spacing: 0.5px;
                color: $light-font;
                margin-left: $px5;
                span {
                  width: $px5;
                  height: $px5;
                  background: $warning-color;
                  display: inline-block;
                  border-radius: 50%;
                  vertical-align: middle;
                  margin-bottom: $px3;
                }
              }
            }
          }
          .text-right {
            h5 {
              margin-bottom: 0;
              font-weight: 600;
            }
          }
          + .summary-card {
            margin-top: $px10;
          }
        }
      }
      .cashback {
        padding-top: calc(
          #{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      .cart-checkout {
        position: relative;
        .details {
          margin: $px18 0;
          h4 {
            margin-bottom: 0;
          }
        }
        .btn {
          padding: calc(
              #{$px8} + (14 - 8) * ((100vw - #{$px320}) / (1920 - 320))
            )
            calc(#{$px10} + (28 - 10) * ((100vw - #{$px320}) / (1920 - 320)));
        }
      }
      .tips {
        h5 {
          font-weight: normal;
          font-size: $px16;
          line-height: $px19;
          letter-spacing: 0.005em;
          color: $font-color;
          text-transform: capitalize;
        }
        ul {
          margin-left: -$px5;
          padding-top: 0;
          padding-bottom: $px12;
          li {
            display: inline-block;
            background-color: white;
            border: $px1 solid $color-primary;
            border-radius: $px4;
            color: $color-primary;
            cursor: pointer;
            font-size: $px14;
            font-weight: 600;
            line-height: $px22;
            letter-spacing: 0.005em;
            width: $px65;
            height: $px32;
            text-align: center;
            padding-top: $px4;
            text-transform: capitalize;
            margin-bottom: $px10;
            margin-left: $px5;
            &.active {
              background-color: $color-primary;
              color: $white;
            }
          }
        }
      }
    }
    .cart-checkout {
      padding: $px30;
      border-top: $px1 solid $light-border;
      position: absolute;
      width: 100%;
      bottom: 0;
      background-color: $transparent;
      .btn {
        text-transform: capitalize;
      }
      .details {
        display: flex;
        align-items: center;
        margin-bottom: $px18;
        h4 {
          font-size: $px20;
          margin-bottom: 0;
          text-transform: capitalize;
          font-weight: 600;
          line-height: $px24;
        }
        span {
          margin-left: auto;
          text-transform: uppercase;
          font-weight: 700;
          font-size: $px20;
          line-height: $px24;
        }
      }
    }
  }
}
@media (max-width: 1366px) {
  .delivery-timeline {
    .media {
      .media-body {
        .delivery-content {
          h5 {
            width: 60%;
          }
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .delivery-timeline {
    padding-right: 0;
    .media {
      .media-body {
        .delivery-content {
          h5 {
            width: 74%;
          }
          label {
            width: 100% !important;
          }
        }
        .timeline-card {
          ul {
            li {
              width: 50%;
              &:first-child {
                width: 70%;
              }
            }
          }
        }
      }
    }
  }
  .side-cart {
    &.checkout-cart {
      .summary {
        .empty-item {
          p {
            width: 100%;
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .delivery-timeline {
    .media {
      .media-body-ai {
        margin-left: $px66;
      }
    }
  }
  .side-cart {
    &.checkout-cart {
      background-color: $white;
      .summary,
      .cashback,
      .brand-section {
        padding-left: 0;
      }
      .summary,
      .cashback {
        .summary-card {
          .item-content {
            ul {
              width: 45%;
            }
          }
        }
      }
      .summary {
        > ul {
          width: 100%;
        }
      }
      .cashback {
        width: 100%;
      }
    }
  }
}
@media (max-width: 767px) {
  .delivery-timeline {
    .media {
      .media-body {
        .timeline-card {
          ul {
            li {
              width: 100% !important;
            }
          }
        }
        .dine-timeline {
          .delivery-content {
            .radio-credit {
              label {
                + label {
                  margin-left: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .delivery-timeline {
    .media {
      .icon-main {
        display: none;
      }
      .media-body {
        margin-left: 0;
        .timeline-card {
          ul {
            display: block;
            li {
              display: block;
              + li {
                margin-top: $px15;
              }
              &:last-child {
                text-align: left;
              }
            }
          }
          .dine-booking {
            .media {
              .icon-booking {
                transform: scale(0.8);
              }
              .media-body {
                margin-left: $px10;
              }
            }
            .row {
              [class^='col-'] {
                &:nth-child(2) {
                  margin-top: calc(
                    #{$px15} + (25 - 15) * ((100vw - #{$px320}) / (1920 - 320))
                  );
                }
              }
            }
          }
        }
        .delivery-content {
          .radio-credit {
            label {
              + label {
                margin-left: 0;
              }
            }
            .d-inline-block {
              display: block !important;
            }
          }
          h5 {
            width: 90%;
          }
          ul {
            li {
              h5 {
                width: 74%;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 360px) {
  .delivery-timeline {
    .media {
      .media-body {
        .delivery-content {
          h5 {
            width: 83%;
          }
        }
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .delivery-timeline {
    .media {
      .media-body {
        .dine-timeline {
          .delivery-content {
            .radio-credit {
              label {
                + label {
                  margin-left: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
.body-rtl {
  .checkout-cart.side-cart.checkout-cart {
    .cashback {
      // padding-left: unset;
      padding-right: calc(
        #{$px25} + (50 - 25) * ((100vw - #{$px320}) / (1920 - 320))
      );
      ul {
        padding-left: unset;
        padding-right: 0;
      }
    }
  }
  .cart-checkout {
    .details {
      span {
        margin-left: unset;
        margin-right: auto;
      }
    }
  }
  .delivery-timeline {
    padding-left: 2.9375rem;
    .media {
      .media-body {
        margin-left: unset;
        margin-right: 1rem;
        &::before {
          right: -41.5px;
          left: unset;
        }
        .timeline-card {
          text-align: right;
        }
        .delivery-content {
          .radio-credit {
            h6 {
              padding-left: unset;
              padding-right: 0.625rem;
            }
            input {
              left: unset;
              right: 0.325rem;
              margin-left: 1rem;
              margin-right: unset;
            }
            /*.d-inline-block {
              #edo-ani {
                left: unset;
              }
            }*/
            .saved-details {
              padding-left: unset;
              padding-right: calc(
                1.5625rem + (40 - 25) * ((100vw - 20rem) / (1920 - 320))
              );
            }
          }
        }
      }
    }
  }
  .fixed-cart {
    right: 12% !important;
  }
  @media (max-width: 992px) {
    .delivery-timeline {
      padding-left: 2.9375rem;
      .media {
        .media-body-ai {
          margin-right: $px66;
        }
      }
    }
  }
}
</style>
